import { render, staticRenderFns } from "./PendingTransaction.vue?vue&type=template&id=c4b7e00e&scoped=true&"
import script from "./PendingTransaction.vue?vue&type=script&lang=js&"
export * from "./PendingTransaction.vue?vue&type=script&lang=js&"
import style0 from "./PendingTransaction.vue?vue&type=style&index=0&id=c4b7e00e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4b7e00e",
  null
  
)

export default component.exports